// Externe Bibliotheken
import React, { Component } from 'react';

// Interne Module
import spsHelper from '../spsHelper';
import { errorReport } from '@/_helper/errorReport';
import PaymentError, { PaymentType } from '@/class/error/PaymentError';

let sps;

class PayPal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formValid: false,
            isLoading: true,
            initSuccess: false,
        };

        sps = new spsHelper(props.spsUrl);
        sps.loadJquery(this.initPayPal.bind(this));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.formValid && !this.state.formValid) {
            const paymentData = Object.assign(this.props.paymentData, {
                paymentValid: false,
            });
            this.props.setPaymentData(paymentData);
        }

        if (
            (prevState.isLoading && !this.state.isLoading && this.props.active) ||
            (!prevProps.active && this.props.active && window.sps)
        ) {
            try {
                this.initPayPal(true);
            } catch (error) {
                errorReport(error instanceof PaymentError ? error.toString() : error);
            }
        }
    }

    initPayPal(load) {
        this.setState({
            isLoading: true,
        });

        const interval = setInterval(function () {
            if (window.C24SpsClient !== undefined && window.C24SpsClient.defaults !== undefined) {
                clearInterval(interval);
                createSPSEvents();
            }
        }, 500);

        const createSPSEvents = () => {
            let $this = this;
            spsHelper.initSps();

            window.sps = new window.C24SpsClient('payPal', {
                onPaypalCancel: () => {
                    $this.setState({ formValid: false });
                },
                onPaypalError: () => {
                    $this.setState({ formValid: false });
                    throw new PaymentError('transaction failed', PaymentType.PayPal);
                },
                onPaypalComplete: () => {
                    let billingAgreement = this.props.paymentData?.spsPayPalBillingAgreement ?? 'latest';

                    const paymentData = Object.assign(this.props.paymentData, {
                        paymentValid: true,
                        paymentDataType: 'paypal_sps',
                        accountOwner: ' ',
                        accountNumber: this.props.paymentData.paypalAccountNumber,
                        externalReferenceNumber: billingAgreement,
                    });

                    this.props.setPaymentData(paymentData);
                    this.props.setPaypalInitSuccess();

                    this.setState({
                        formValid: true,
                        paymentData: paymentData,
                        initSuccess: true,
                    });
                },
            });

            if (load !== undefined && load === true) {
                // new property
                let identifier = this.props.paymentData.spsPayPalTransactionId;
                if (identifier === undefined) {
                    // old property
                    identifier = this.props.paymentData.paypalBillingAgreement;
                }

                if (document.querySelector('#paypal-btn')) {
                    window.sps.initPaypalButton('paypal-btn', identifier, 'pill', 'responsive', 'blue', 'pay', true);
                }
            }

            if (!this.state.spsInit) {
                this.setState({
                    spsInit: true,
                    isLoading: false,
                });
            }

            Object.assign(this.props.paymentData, {
                selected: 'payPal',
            });
        };
    }

    getsFormElements() {
        return <div id="paypal-btn"></div>;
    }

    render() {
        return (
            <>
                {!this.state.spsInit && this.props.active && (
                    <div className="loading card-loading lazy-load-background">
                        <span className="loading-bullet"></span>
                    </div>
                )}
                {this.props.active && (
                    <div className={`card-body ${this.props.active && this.state.spsInit && 'active'}`}>
                        {!this.state.initSuccess && this.getsFormElements()}
                        <div className="trust-element">
                            <i className="material-symbols-outlined">check</i>
                            Die Übertragung Ihrer Zahldaten erfolgt verschlüsselt über einen Sicherheitsserver.
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default PayPal;
